import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
  columnDateField,
} from "utils/tables-utils";

export default function PedidoDetailsOds({ ods }) {
  const odsColumnModel = [
    columnNumberField({
      dataField: "NumeroOd",
      text: "Nr OD",
    }),
    columnPriceField({
      dataField: "VlrOd",
      text: "Valor OD",
    }),
    columnDateField({
      dataField: "DataGeracaoOd",
      text: "Data Geração",
    }),
    columnDateField({
      dataField: "DataEmissaoOd",
      text: "Data Emissão",
    }),
    columnDateField({
      dataField: "DataComplementoExpedicao",
      text: "Data Complemento Expedição",
    }),
    columnDateField({
      dataField: "DataComplementoExportacao",
      text: "Data Complemento Exportação",
    }),
    columnDateField({
      dataField: "DataComplementoFaturamento",
      text: "Data Complemento Faturamento",
    }),
    columnTextField({
      dataField: "Situacao",
      text: "Situação",
      align: "center",
    }),
    columnDateField({
      dataField: "DataEmbarque",
      text: "Data Embarque",
    }),
    columnDateField({
      dataField: "DataInicioFaturamento",
      text: "Data Inicio Faturamento",
    }),
    columnDateField({
      dataField: "DataLimiteFaturamento",
      text: "Data Limite Faturamento",
    }),
    columnTextField({
      dataField: "NomeTransportadoraDespacho",
      text: "Nome Transportadora Despacho",
    }),
    columnTextField({
      dataField: "NomeTransportadoraRedespacho",
      text: "Nome Transportadora Redespacho",
    }),
  ];

  return (
    <ToolkitTable
      dataTable={ods}
      columnModel={odsColumnModel}
      keyField="NumeroOd"
      pagination={false}
      style={{
        boxShadow: "none",
      }}
    />
  );
}
